import { LicenseInfo as LicenseInfoMuiXProp } from '@mui/x-license';
import { setLicenseKey } from 'survey-core';

export const registerLicenses = () => {
  //Development use, support, and updates expiry date: Jan 26, 2027
  LicenseInfoMuiXProp.setLicenseKey(
    '908997d62b027cf900685115dcd5627aTz0xMjQ4NjksRT0xODAxMDk0Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
  );

  //SurveyJS, expiry date: Nov 30, 2024
  setLicenseKey('NjFiZjBmOGItYjZkMi00MGZjLWE4ZTMtN2NlMzU3ODA3YWY3OzE9MjAyNC0xMS0zMA==');
};
